import axios from 'axios';
import { useState } from 'react'
import { NotificationType } from 'react-app-env';
import { useSelector } from 'react-redux';
import Loading from '@components/common/Loading';
import { TextInputDefault } from '@components/form/TextInput'
import { API_URL } from '@redux/api';
import { RootState } from '@redux/store';
import { ChangeAccountPassword, validateChangePassword } from '@redux/validations/accountSettings';
import Notification from '@components/common/Notification';

type ErrorsType = {
  oldPassword?: string;
  newPassword?: string;
  confirmNewPassword?: string;
};

const ChangePassword = () => {

  const { user } = useSelector((state: RootState) => state.auth);

  const [oldPassword, setOldPassword] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmNewPassword, setConfirmNewPassword] = useState<string>("");

  const [errors, setErrors] = useState<ErrorsType>({});
  const [notification, setNotification] = useState<NotificationType | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const isValid = (payload: ChangeAccountPassword) => {
    const { errors, isValid } = validateChangePassword(payload);
    if (!isValid) {
      setErrors(errors);
    }
    return isValid;
  };

  const onSubmit = async() => {
    setIsLoading(true);
    setErrors({});
    setNotification(null);

    const payload = {
      email: user.email,
      old_password: oldPassword,
      new_password: newPassword,
      confirm_password: confirmNewPassword
    };

    if(isValid(payload)) {
      const response = await axios.put(`${API_URL}/admin/change-password`, payload);
      const { status, data } = response;
      
      if(status === 200) {
        const { message } = data;
        setNotification({
          isError: false,
          title: "Sukses",
          text: message
        });
        
        setTimeout(() => {
          setIsLoading(false);
          setNotification(null);
        }, 3000);
      } else {
        setIsLoading(false);
        setNotification({
          isError: true,
          title: "Terjadi kesalahan",
          text: "Coba beberapa saat lagi.",
        });
      };
    } else {
      setIsLoading(false);
      setNotification({
        isError: true,
        title: "Data tidak lengkap",
        text: "Mohon lengkapi formulir di atas dengan benar",
      });
    };
  };
  
  return (
    <div className="bg-white p-4 rounded-xl mt-10">
      <h2 className="font-semibold">Ganti Password</h2>
      <hr className="my-4"/> 

      <div className="mt-3">
        <TextInputDefault
          label="Password Lama"
          placeholder="Masukkan password lama"
          name="oldPassword"
          type="password"
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
          disabled={isLoading}
          error={errors?.oldPassword}
        />
      </div>
      <div className="mt-3">
        <TextInputDefault 
          label="Password Baru"
          placeholder="Masukkan password baru"
          name="name"
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          disabled={isLoading}
          error={errors?.newPassword}
        />
      </div>
      <div className="mt-3">
        <TextInputDefault 
          label="Konfirmasi Password Baru"
          placeholder="Masukkan kembali password baru"
          name="confirmNewPassword"
          type="password"
          value={confirmNewPassword}
          onChange={(e) => setConfirmNewPassword(e.target.value)}
          disabled={isLoading}
          error={errors?.confirmNewPassword}
        />
      </div>

      <div className="mt-4">
        <Notification notification={notification} />
      </div>

      <div className='mt-8'>
        { isLoading ?
          <div>
            <Loading loading={isLoading} type='beat-loader' size={10} parentClass='text-sm' />
          </div>
          : <button
            type='submit'
            onClick={onSubmit}
            className='w-full justify-center bg-orange-600 text-white rounded-lg py-3 font-semibold'
          >
            Simpan
          </button>
        }
      </div>
    </div>
  )
}

export default ChangePassword